export interface Transaction {
  id: number;
  companyId: number;
  description: string;
  valueDate: Date;
  operationDate: Date;
  accountId: number;
  credit: number;
  debit: number;
  currentBalance: number;
  type: TransactionType;
  status: TransactionStatus;
  reference: string;
  synchronize: boolean;
  externalRef: number;
  isReconciled: boolean;
}

export type TransactionDto = Partial<Transaction>;

export enum TransactionType {
  INCOME = 'Income',
  EXPENSE = 'Expense',
  TRANSFER = 'Transfer',
}

export enum AccountType {
  BANK = 'BANK',
  CASH = 'CASH',
  MOBILE = 'MOBILE',
}

export enum TransactionStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
}

export interface TransactionListResponse {
  items: Transaction[];
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

export interface PresignedPutDto {
  url: string;
  key: string;
  headers?: Record<string, string>;
}
